import {DossierInterventionActiviteEau} from './dossierInterventionActiviteEau.model';

export class ActiviteEau {
    id: number;
    visit_date: string;
    humidity: string;
    temperature: string;
    dossier_intervention_activite_eau: DossierInterventionActiviteEau;
    gpl: string;
    public constructor(init?: Partial<ActiviteEau>) {
      Object.assign(this, init);
    }
  }
